<app-topbar></app-topbar>
<div class="container mr-top-56">
    <!-- <h1 class="mainhdng">Dashboard</h1> -->
    <h1 class="mainhdng">Our Products</h1>
    
    <!-- Products Row -->
    <div class="row d-flex justify-content-between">
    <div class="col-md-6 spwidth firstbox prdct_main_div resprowmlmr0 frMbl comingsoonstatus{{product.comingsoon}}" *ngFor = "let product of Products">
        <div class="row">
<div class="col-4 text-right">
            <div class="col-md-12 col-sm-12 col-xs-12 prdct_img_div">
           <img src="{{product_image_url}}{{product.icon}}" alt="{{product.name}}"/>
        </div>
        </div>
        <div class="col-8">
            <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 prdct_hdng_div">
            <h3 class="frstboxhdng">{{product.name}}</h3>
            <p class="boxpara">{{product.description}}</p>
            <p class="boxpara_bold clrgreen" *ngIf="product.comingsoon == 1"><b>Coming soon!</b></p>    
        </div>
        <div class="col-9 py-1">Finally, a way to automate and enhance photo sharing.</div>
    </div>
        </div>
        <!-- <div class="col-2">&nbsp;</div> -->
        <div class="col-md-12 text-center col-sm-12 col-xs-12 mr-topbttm-auto prdct_bttn_div mt-5">
            <button class="boxbluebuttn " routerLink ="/add-product-subscriptions/{{product.comingsoon == 1 ? '' : product.id}}">Add Product</button>
            <div class="common manage_product_text d-none">
                <p class="boxpara clrgry text-right">Activation Date:08/22/20</p>
                <p class="boxpara clrgry text-right">Paid with Visa:*8965</p>
                <p class="text-right"><a href="" class="boxpara clrblue">Manage Subscription</a></p>
            </div>
        </div>
    </div>
</div>
</div>

  
    <!-- Products Row -->

    <!-- Options Row -->
   <div class="heading">Manage your settings</div>
	<div class="row optionrow mr-top-56 mr-top-26 d-flex justify-content-between">
        <div routerLink ="/profile" class="col-md-6 col-sm-12 col-12 col-xs-12 mr-topbttm-auto text-center optionbx mb-4" id="option1">
            <div class="row d-flex">
                <div class="col-lg-2 col-md-3 col-sm-2 col-2 d-flex align-items-center mr-sm-2 mr-4 ">
                    <div class="prflimgdiv ">
                        <img src="assets/images/profiles.png" class="profileimgs">
                        <img src="assets/images/profiles-selected.png" class="profileimgs-sel">
                     </div>
                 </div>
            <div class="col-lg-9 col-md-8 col-sm-7 col-8 margin5">
            <h4 class="prflhdng text-left my-2">Profile</h4>
            <p class="prflpara text-left">Edit Profile</p></div></div> 				
        </div>


        <div routerLink ="/company-store" class="col-md-6 col-sm-12 col-12 col-xs-12 mr-topbttm-auto text-center optionbx mb-4" id="option2">
            <div class="row">
                <div class="col-lg-2 col-md-3 col-sm-2 col-2 d-flex align-items-center  mr-sm-2 mr-4">
                    <div class="prflimgdiv">
                        <img src="assets/images/companies-n-stores.png" class="profileimgs">
                        <img src="assets/images/companies-n-stores-selected.png" class="profileimgs-sel">
                    </div>
                </div>
                <div class="col col-sm-7-lg-9 col-md-8 col-8 margin5">
                    <h4 class="prflhdng text-left my-2">Companies & Stores</h4>
                    <p class="prflpara text-left">Manage</p>  
                </div>
            </div>
        </div>



        <div routerLink ="/subscriptions" class="col-md-6 col-sm-12 col-12 col-xs-12 mr-topbttm-auto text-center optionbx mb-4" id="option3">
            <div class="row">
                <div class="col-lg-2 col-md-3 col-sm-2 col-2 d-flex align-items-center  mr-sm-2 mr-4">
                    <div class="prflimgdiv">
                        <img src="assets/images/products.png" class="profileimgs">  
                        <img src="assets/images/products-selected.png" class="profileimgs-sel"> 
                     </div>
                 </div> 
                <div class="col-lg-9 col-md-8 col-sm-7 col-8 margin5">
                    <h4 class="prflhdng text-left my-2">Products & Suscriptions</h4>
                   <p class="prflpara text-left">Manage</p>
                 </div>
            </div>				
        </div>



           <div routerLink ="/payments" class="col-md-6 col-sm-12 col-12 col-xs-12 mr-topbttm-auto text-center optionbx mb-4" id="option4">
            <div class="row">
                <div class="col-lg-2 col-md-3 col-sm-2 col-2 d-flex align-items-center  mr-sm-2 mr-4">
                    <div class="prflimgdiv">
                        <img src="assets/images/payment.png" class="profileimgs">
                        <img src="assets/images/payment-selected.png" class="profileimgs-sel">
                    </div>
                 </div> 
                <div class="col-lg-9 col-md-8 col-sm-7 col-8 margin5">
                    <h4 class="prflhdng text-left my-2">Payment & Billing</h4>
                    <p class="prflpara text-left">View</p>    
                 </div>
            </div>              
        </div>





      <!--   <div routerLink ="/payments" class="col-md-6 col-sm-12 col-xs-12 mr-topbttm-auto text-center optionbx" id="option4">
            <div class="prflimgdiv">
                <img src="assets/images/payment.png" class="profileimgs">
                <img src="assets/images/payment-selected.png" class="profileimgs-sel">
            </div>
            <h4 class="prflhdng">Payment & Billing</h4>
            <p class="prflpara">View</p>					
        </div>			
    </div> -->
    <!-- Options Row -->
</div>
<style>
    .firstbox.comingsoonstatus1 h3{    color: #1F9C8F;}
    .firstbox.comingsoonstatus1
    {    
        padding: 40px 41px 40px 45px;background: #F5F5F5;border: 1px solid rgba(31, 156, 143, 0.25);
        box-sizing: border-box;border-radius: 30px;pointer-events:none;
    }
    .firstbox.comingsoonstatus1 .boxbluebuttn
    {
        background: rgba(191, 191, 191, 0.5);border: 1px solid #ded7d7;
    }
</style>